import { toast } from 'react-toastify';

import Props from './type';

export const showToast = ({ message, ...props }: Props) => {
  toast(() => <div className='w-full py-2.5! text-right'>{message}</div>, { ...props });
};
